export default __webpack_public_path__ + "static/media/1882.0c93f08c.png";